(() => {
  if (window.__pdlMobileRackCtaV2) return;
  window.__pdlMobileRackCtaV2 = true;

  const MOBILE_QUERY = '(max-width: 999px)';
  const BUTTON_ID = 'HeaderDrawer-compatibilidade-racks';
  const TARGET_PATH = '/pages/racks-e-transbikes';
  const ICON_URL = 'https://cdn.shopify.com/s/files/1/0824/5041/5841/files/pedalokos-compatibilidade-racks-carro-bikes.png?v=1789138399';
  const STYLE_ID = 'pdl-mobile-tools-compact-v2';

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media screen and (max-width: 999px) {
        .header-drawer .menu-drawer,
        .header-drawer .menu-drawer__navigation,
        .header-drawer .menu-drawer__submenu,
        .header-drawer .menu-drawer__inner-submenu {
          background: #ffffff !important;
          background-color: #ffffff !important;
        }

        .header-drawer .pdl-mobile-msb-entry,
        .header-drawer .pdl-mobile-rack-entry {
          box-sizing: border-box !important;
          width: 100% !important;
          margin-left: 0 !important;
          margin-right: 0 !important;
          padding: 0 12px !important;
        }

        .header-drawer .pdl-mobile-msb-entry:not(.pdl-mobile-rack-entry) {
          margin-top: 13px !important;
          margin-bottom: 7px !important;
        }

        .header-drawer .pdl-mobile-rack-entry {
          margin-top: 7px !important;
          margin-bottom: 7px !important;
        }

        .header-drawer .pdl-mobile-msb-entry__link {
          min-height: 68px !important;
          grid-template-columns: 50px minmax(0, 1fr) !important;
          gap: 10px !important;
          padding: 10px 11px !important;
          border: 1px solid #f8c10e !important;
          border-radius: 10px !important;
          background: #ffffff !important;
          color: #171717 !important;
          box-shadow: 0 4px 11px rgba(17, 17, 17, .06) !important;
        }

        .header-drawer .pdl-mobile-msb-entry__link:active {
          background: #ffffff !important;
        }

        .header-drawer .pdl-mobile-msb-entry__icon {
          width: 50px !important;
          height: 32px !important;
        }

        .header-drawer .pdl-mobile-msb-entry__copy {
          gap: 3px !important;
        }

        .header-drawer .pdl-mobile-msb-entry__copy small {
          font-size: .52rem !important;
          letter-spacing: .085em !important;
        }

        .header-drawer .pdl-mobile-msb-entry__copy strong {
          font-size: .82rem !important;
          line-height: 1.13 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const normalizeEntries = (msbEntry, rackEntry) => {
    [msbEntry, rackEntry].filter(Boolean).forEach((entry) => {
      entry.style.width = '';
      entry.style.marginLeft = '';
      entry.style.marginRight = '';
    });
  };

  const ensureRackCta = () => {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    ensureStyles();

    const msbLink = document.getElementById('HeaderDrawer-monte-sua-bike');
    const msbEntry = msbLink?.closest('.pdl-mobile-msb-entry');
    if (!msbEntry) return;

    let rackLink = document.getElementById(BUTTON_ID);
    let rackEntry = rackLink?.closest('.pdl-mobile-rack-entry');

    if (!rackEntry) {
      rackEntry = msbEntry.cloneNode(true);
      rackEntry.classList.add('pdl-mobile-rack-entry');
      rackEntry.setAttribute('aria-label', 'Ferramenta Compatibilidade de Racks');

      const link = rackEntry.querySelector('a');
      if (!link) return;

      link.id = BUTTON_ID;
      link.setAttribute('href', TARGET_PATH);
      link.removeAttribute('aria-current');

      const icon = rackEntry.querySelector('.pdl-mobile-msb-entry__icon img');
      if (icon) {
        icon.src = ICON_URL;
        icon.alt = '';
        icon.setAttribute('width', '46');
        icon.setAttribute('height', '46');
        icon.setAttribute('loading', 'eager');
      }

      const eyebrow = rackEntry.querySelector('.pdl-mobile-msb-entry__copy small');
      const title = rackEntry.querySelector('.pdl-mobile-msb-entry__copy strong');
      if (eyebrow) eyebrow.textContent = 'FERRAMENTA PEDALOKOS';
      if (title) title.textContent = 'Compatibilidade de Racks';

      msbEntry.insertAdjacentElement('afterend', rackEntry);
      rackLink = link;
    }

    normalizeEntries(msbEntry, rackEntry);
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      ensureRackCta();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', schedule);

  const headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    new MutationObserver(schedule).observe(headerGroup, {
      childList: true,
      subtree: true
    });
  }

  const mobileMedia = window.matchMedia(MOBILE_QUERY);
  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', schedule);
  }
})();
